import { createEnum } from "./utils";

const APP_NAME = "Ntwtrk";

const DEBOUNCE_TIMER = 500;

const MODAL_ID = {
  ADD_MODAL: "add-modal",
  CHANGE_STATUS: "change-status",
  REASON_MODAL: "reason-modal",
  ADD_USER: "add-user",
  ADD_ROLE: "add-role",
  ADD_PERMISSION: "add-permission",
  ADD_CATEGORY: "add-category",
  ADD_CAMPAIGN: "add-campaign",
  ADD_SUBCATEGORY: "add-sub-category",
  ADD_VENDOR: "add-vendor",
  ADD_PRODUCT: "add-product",
  ADD_OFFER: "add-offer",
  ADD_ADMIN: "add-admin",
  ADD_ALERT: "add-alert",
  EDIT_ALERT: "edit-alert",
  CONFIRM_DELETE: "confirm-delete-done",
  VIEW_IMAGE: "view-image",
  VIEW_OFFERS: "view-offers",
  VENDOR_REJECTION: "vendor-rejection",
  APPLY_FILTER: "apply-filter",
  SELFIE_VALIDATE: "selfie-validate",
  SELFIE_VALIDATE_REJECT: "selfie-validate_reject",
  SEND_MESSAGE: "send-message",
  SUSPEND_ADMIN: "suspend-admin",
  DELETE_ACTIVITY: "delete-activity",
  REJECT_ACTIVITY: "reject-activity",
  USER_EDIT: "user-edit",
  CHANGE_PASSWORD: "change-password",
  SUSPEND_INSTITUTION: "suspend-institution",
  SUSPEND_MEMBER: "suspend-member",
  LOGOUT: "logout",
  CONTENT_DETAIL: "content-detail",
  REPORT_DETAIL: "report-detail",
  ADD_COUNTRY_PRICE: "add-country-price",
};
createEnum(MODAL_ID);

const PAGINATION = {
  DEFAULT_ROWS_PER_PAGE: 10,
  DEFAULT_PAGE_NUMBER: 1,
};
createEnum(PAGINATION);

const VENDOR_TYPES = {
  "cosmetic store": "Cosmetic Store",
  pharmacy: "Pharmacy",
  other: "Other",
};
createEnum(VENDOR_TYPES);

const UNIT_TYPES = {
  mg: "mg",
  g: "g",
  kg: "kg",
  ml: "ml",
  l: "l",
  unit: "unit  ",
};
createEnum(UNIT_TYPES);

const OFFER_TYPES = { product: "Product", cart: "Cart" };
createEnum(OFFER_TYPES);

const DISCOUNT_TYPES = { percentage: "Percentage", flat: "Flat" };
createEnum(DISCOUNT_TYPES);

const VALIDATION_ERROR_MESSAGES = {
  EMAIL_FORMAT: "Please enter a valid email address!",
  PASSWORD_FORMAT: "Please enter a valid password!",
  ONLY_NUMBERS: "Only numeric values allowed!",
  INVALID_MOBILE: "Please enter a valid mobile number!",
  ZIP_CODE_FORMAT: "Please enter a valid ZIP code!",
  MIN_LENGTH: (name: string) => `${name} should be greater than 2 characters!`,
  ALPHABETS_ONLY: (name: string) => `${name} should only contain alphabets!`,
};
createEnum(VALIDATION_ERROR_MESSAGES);

const VENDOR_STATUS = ["pending", "approved", "rejected"];
createEnum(VENDOR_STATUS);

const THEME_OPTIONS: Record<string, any>[] = [
  { label: "Default", value: "default" },
  { label: "Blue", value: "blue-theme" },
  { label: "Green", value: "green-theme" },
];

const PASSWORD_INSTRUCTIONS = [
  "contain at least 1 lowercase character",
  "contain at least 1 uppercase character",
  "contain at least 1 special character",
  "be at least 8 characters long",
  "be maximum 20 characters long",
];

export {
  MODAL_ID,
  DEBOUNCE_TIMER,
  PAGINATION,
  VENDOR_TYPES,
  OFFER_TYPES,
  DISCOUNT_TYPES,
  VALIDATION_ERROR_MESSAGES,
  VENDOR_STATUS,
  UNIT_TYPES,
  APP_NAME,
  THEME_OPTIONS,
  PASSWORD_INSTRUCTIONS,
};

export const tempPermissions = [
  "get alert",
  "get dashboard",
  "get institution",
  "get activity",
];

export const severityOptions = [
  // {
  //   label: "Critical",
  //   value: "critical",
  // },
  {
    label: "High",
    value: "high",
  },
  {
    label: "Medium",
    value: "medium",
  },
  {
    label: "Low",
    value: "low",
  },
];

export const alertTypeOptions = [
  { label: "Moderation", value: "moderation" },
  { label: "Identity", value: "identity" },
  { label: "Security", value: "security" },
  { label: "Payment", value: "payment" },
  { label: "Compliance", value: "compliance" },
  { label: "System", value: "system" },
];

export const memberStatusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Suspend", value: "suspended" },
  { label: "Block", value: "block" },
];

export const alertStatusOptions = [
  { label: "Open", value: "OPEN" },
  { label: "In Review", value: "IN_REVIEW" },
  { label: "Action Taken", value: "ACTION_TAKEN" },
  { label: "Resolved", value: "RESOLVED" },
  { label: "Archived", value: "ARCHIVED" },
];
export const commonFilter = (
  startDate: string | null,
  endDate: string | null,
) => ({
  startDate: {
    defaultValue: startDate || "",
    validations: {},
    isControlled: true,
    controlType: "date",
    label: "Start Date",
  },
  endDate: {
    defaultValue: endDate || "",
    validations: {},
    isControlled: true,
    controlType: "date",
    label: "End Date",
  },
});

export const events = [
  {
    title: "Coffee & Chat Meet up",
    creator: "Max Marvin",
    dateTime: "27 September 2025 - 5:00 PM",
    attendees: "36/50",
    imageUrl: "/images/chat.jpg",
    category: "Health & Wellness",
    platform: "Facebook",
  },
  {
    title: "Women for Wellness Foundation",
    creator: "Aanya Desai",
    dateTime: "28 September 2025 - 10:00 AM",
    attendees: "65/100",
    imageUrl: "/images/wellness.jpg",
    category: "Health & Wellness",
    platform: "Eventbrite",
  },
  {
    title: "Moms & Morning Yoga",
    creator: "Riya Kapoor",
    dateTime: "29 September 2025 - 7:30 AM",
    attendees: "42/60",
    imageUrl: "/images/yoga.jpg",
    category: "Family & Parenting",
    platform: "Meetup",
  },
  {
    title: "Career Boost Workshop",
    creator: "Rohan Mehta",
    dateTime: "30 September 2025 - 2:00 PM",
    attendees: "80/120",
    imageUrl: "/images/career.jpg",
    category: "Education & Employment",
    platform: "Eventbrite",
  },
];

export enum APPROVAL_STATUS {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  DELETED = "DELETED",
}
